import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import extractText from 'flarum/common/utils/extractText';

function infoTrans(page, key) {
  return app.translator.trans(`pakt21-beta.forum.info_pages.${page}.${key}`);
}

const MANIFEST_SECTIONS = [
  'problem',
  'normal_people',
  'actions',
  'truth',
  'mutual_aid',
  'trust',
  'shared_economy',
  'arena',
  'belonging',
  'never_become',
  'invitation',
];

const RULE_SECTIONS = [
  'operator',
  'definitions',
  'services',
  'contract',
  'technical',
  'registration',
  'account',
  'pakt21_id',
  'profile_trust',
  'content',
  'prohibited',
  'forum',
  'anonymous',
  'lounge',
  'market',
  'collaboration',
  'reviews',
  'arena',
  'moderation',
  'reporting',
  'privacy',
  'ending',
  'complaints',
  'liability',
  'changes',
  'law',
];

function infoText(page, key) {
  return extractText(infoTrans(page, key));
}

function renderDocumentBody(page, key) {
  return infoText(page, key)
    .split(/\n\s*\n/)
    .filter(Boolean)
    .map((block, index) => {
      const lines = block.split('\n').map((line) => line.trim()).filter(Boolean);

      if (lines.length && lines.every((line) => line.startsWith('• '))) {
        return (
          <ul key={`${key}-list-${index}`}>
            {lines.map((line) => <li key={line}>{line.slice(2)}</li>)}
          </ul>
        );
      }

      return <p key={`${key}-paragraph-${index}`}>{block}</p>;
    });
}

export default class Pakt21InfoPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    const currentPath = typeof m.route?.get === 'function' ? m.route.get().split('?')[0] : '/manifest';

    this.page = currentPath === '/regulamin' ? 'rules' : 'manifest';
    this.bodyClass = `App--pakt21Info App--pakt21Info-${this.page}`;
    app.setTitle(infoTrans(this.page, 'meta_title'));
  }

  viewManifest() {
    return (
      <article className="Pakt21InfoPage-card Pakt21Manifest">
        <p className="Pakt21InfoPage-kicker">{infoTrans('manifest', 'kicker')}</p>
        <h1>{infoTrans('manifest', 'title')}</h1>
        <p className="Pakt21InfoPage-lead">{infoTrans('manifest', 'lead')}</p>
        <blockquote>{infoTrans('manifest', 'quote')}</blockquote>

        {this.viewContents('manifest', MANIFEST_SECTIONS)}

        <div className="Pakt21Manifest-sections">
          {MANIFEST_SECTIONS.map((section, index) => (
            <section className="Pakt21Document-section" id={`manifest-${section}`} key={section}>
              <p className="Pakt21Document-sectionNumber">{String(index + 1).padStart(2, '0')}</p>
              <div>
                <h2>{infoTrans('manifest', `${section}_title`)}</h2>
                {renderDocumentBody('manifest', `${section}_body`)}
              </div>
            </section>
          ))}
        </div>

        <p className="Pakt21InfoPage-closing">{infoTrans('manifest', 'closing')}</p>
      </article>
    );
  }

  viewRules() {
    return (
      <article className="Pakt21InfoPage-card Pakt21Rules">
        <p className="Pakt21InfoPage-kicker">{infoTrans('rules', 'kicker')}</p>
        <h1>{infoTrans('rules', 'title')}</h1>
        <p className="Pakt21InfoPage-version">{infoTrans('rules', 'version')}</p>
        <p className="Pakt21InfoPage-warning">{infoTrans('rules', 'draft_warning')}</p>
        <p className="Pakt21InfoPage-lead">{infoTrans('rules', 'lead')}</p>

        {this.viewContents('rules', RULE_SECTIONS)}

        <div className="Pakt21Rules-sections">
          {RULE_SECTIONS.map((section, index) => (
            <section className="Pakt21Rules-section" id={`rules-${section}`} key={section}>
              <h2><span>{index + 1}.</span> {infoTrans('rules', `${section}_title`)}</h2>
              {renderDocumentBody('rules', `${section}_body`)}
            </section>
          ))}
        </div>
      </article>
    );
  }

  viewContents(page, sections) {
    return (
      <nav className="Pakt21Document-toc" aria-label={infoTrans(page, 'contents_label')}>
        <strong>{infoTrans(page, 'contents_title')}</strong>
        <ol>
          {sections.map((section) => (
            <li key={section}>
              <a href={`#${page}-${section}`}>{infoTrans(page, `${section}_title`)}</a>
            </li>
          ))}
        </ol>
      </nav>
    );
  }

  view() {
    return (
      <div className="Pakt21InfoPage">
        <div className="container containerNarrow">
          <nav className="Pakt21InfoPage-tabs" aria-label={infoTrans(this.page, 'navigation_label')}>
            <Link className={`Button ${this.page === 'manifest' ? 'Button--primary' : ''}`} href="/manifest">
              {app.translator.trans('pakt21-beta.forum.info_pages.navigation.manifest')}
            </Link>
            <Link className={`Button ${this.page === 'rules' ? 'Button--primary' : ''}`} href="/regulamin">
              {app.translator.trans('pakt21-beta.forum.info_pages.navigation.rules')}
            </Link>
          </nav>
          {this.page === 'rules' ? this.viewRules() : this.viewManifest()}
        </div>
      </div>
    );
  }
}
